import React from "react";
import { Dropdown } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "./ColumnToggle.scss";

/**
 * Restores columns that were hidden from a table header.
 * Renders its own panel rather than an antd Menu so it matches the filter
 * dropdowns elsewhere on the page.
 */
const ColumnToggle = ({ hidden = [], allColumns = [], onRestore }) => {
  if (!hidden.length) return null;

  return (
    <Dropdown
      trigger={["click"]}
      placement="bottomRight"
      dropdownRender={() => (
        <div className="coltoggle__panel">
          <div className="coltoggle__head">
            <span>Hidden columns</span>
            <span className="coltoggle__tally">{hidden.length}</span>
          </div>

          <div className="coltoggle__list">
            {hidden.map((key) => {
              const col = allColumns.find((c) => c.key === key);
              return (
                <button
                  type="button"
                  key={key}
                  className="coltoggle__row"
                  onClick={() => onRestore(key)}
                >
                  <PlusOutlined />
                  <span>{col?.label ?? col?.title ?? key}</span>
                </button>
              );
            })}
          </div>

          {hidden.length > 1 && (
            <div className="coltoggle__foot">
              <button type="button" onClick={() => onRestore(hidden)}>
                Restore all
              </button>
            </div>
          )}
        </div>
      )}
    >
      <button
        type="button"
        className="coltoggle__trigger"
        aria-label={`Show ${hidden.length} hidden column(s)`}
        title="Show hidden columns"
      >
        <PlusOutlined />
      </button>
    </Dropdown>
  );
};

export default ColumnToggle;
